import React, { useState, useCallback, useEffect } from 'react';
import SyncLoader from 'react-spinners/SyncLoader';

const MyLoader = () => {
  return <SyncLoader css={{ margin: '10px' }} size={10} color={'#36D7B7'} loading={true} />;
};

export default MyLoader;
